module.exports = __webpack_public_path__ + "static/img/jaeger.a6296f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jaeger.png
// module id = 35
// module chunks = 1